import { t } from "@/lib/i18n";
import { Mic, Square, Loader2 } from "lucide-react";
import { useVoiceRecorder } from "@/hooks/useVoiceRecorder";

export const VoiceButton = ({ onText, disabled }) => {
  const { state, seconds, start, stop } = useVoiceRecorder(onText);
  const recording = state === "recording";
  const busy = state === "transcribing";
  return (
    <button
      type="button"
      data-testid="ai-voice-button"
      data-state={state}
      onClick={recording ? stop : start}
      disabled={disabled || busy}
      aria-label={recording ? t("voice.stop") : t("voice.start")}
      title={recording ? t("voice.stop") : t("voice.start")}
      className={`relative grid h-12 w-12 shrink-0 place-items-center rounded-xl border transition-colors disabled:opacity-40 ${
        recording ? "border-red-500 bg-red-500 text-white" : "border-ac-line bg-ac-surface text-ac-ink hover:border-ac-primary hover:text-ac-primary-ink"
      }`}
    >
      {recording && <span className="absolute inset-0 animate-ping rounded-xl bg-red-500/30" />}
      {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : recording ? <Square className="relative h-4 w-4 fill-current" /> : <Mic className="h-5 w-5" />}
      {recording && (
        <span data-testid="ai-voice-timer" className="absolute -top-7 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-red-500 px-2 py-0.5 font-mono text-[10px] font-bold text-white">
          0:{String(seconds).padStart(2, "0")}
        </span>
      )}
    </button>
  );
};
